import { UserTypes, PropertyInfo, ValidationKeys } from '../constants';

export const PropertyScoutFieldNames = {
    Status: 'status',
    Source: 'source',
    Starred: 'starred',
    ManualSalePrice: 'manual_sale_price',
    ManualPurchasePrice: 'manual_purchase_price',
    GenericData: 'generic_data',
    ValidationFields: 'validation_fields',
};

export const ViabilityLinks = {
    [ValidationKeys.StructuralConstraints]: 'https://www.seismicmaps.org/',
    [ValidationKeys.FloodHazard]: 'https://msc.fema.gov/portal/home',
    [ValidationKeys.EarthquakeHazard]:
    'https://maps.conservation.ca.gov/cgs/informationwarehouse/eqzapp/',
    [ValidationKeys.FireHazard]:
    'https://experience.arcgis.com/experience/03beab8511814e79a0e4eabf0d3e7247/',
    [ValidationKeys.CityHistoricResource]: {
        'SAN JOSE':
      'https://www.sanjoseca.gov/your-government/departments-offices/planning-building-code-enforcement/planning-division/historic-resources/historic-resources-inventory',
        'SAN MATEO':
      'https://cityofsanmateo.maps.arcgis.com/apps/mapviewer/index.html',
        'REDWOOD CITY': 'https://webgis.redwoodcity.org/community/',
    },
    [ValidationKeys.CityVsCounty]: {
        'SANTA CLARA':
      'https://sccplanning.maps.arcgis.com/apps/webappviewer/index.html?id=1f39e32b4c0644b0915354c3e59778ce',
        'SAN MATEO':
      'https://data-smcmaps.opendata.arcgis.com/datasets/smcmaps::city-boundary/explore',
    },
    [ValidationKeys.ZoningJurisdiction]: {
        CAMPBELL:
      'https://gis.campbellca.gov/Html5Viewer/Index.html?configBase=http://gis.campbellca.gov/Geocortex/Essentials/REST/sites/Campbell_Public/viewers/Public_Viewer/virtualdirectory/Resources/Config/Default',
        'MENLO PARK':
      'https://data.menlopark.gov/datasets/MenloPark::zoning/explore?location=37.442558,-122.195542,18.36',
        'SANTA CLARA':
      'https://map.santaclaraca.gov/vertigisstudio/web/?app=43ab0b528f724224ab92b76891717ce5',
        SARATOGA:
      'https://www.saratoga.ca.us/DocumentCenter/View/57/Zoning-Map-PDF?bidId=',
    },
};

export const LotFits = {
    true: true,
    false: false,
    unknown: null,
};

export const doesLotFit = (propertyDetails) => {
    const { lot_analysis } = propertyDetails;
    const hasLotFitsInfo =
    lot_analysis?.AH1 &&
    lot_analysis.AH1?.house_does_fit !== undefined &&
    lot_analysis.AH1?.house_does_fit !== null;
    return hasLotFitsInfo
        ? LotFits[lot_analysis.AH1.house_does_fit]
        : LotFits.unknown;
};

export const countGoodComps = (comps) =>
    comps.reduce((acc, comp) => (Number(comp.sale_price) > 0 ? acc + 1 : acc), 0);

export const computeAvgSalePrice = (comps) => {
    if (!comps?.length) {
        return null;
    }
    const goodComps = comps.filter((comp) => Number(comp.sale_price) > 0);
    const total = goodComps.reduce(
        (acc, comp) => acc + Number(comp.sale_price),
        0
    );
    return `$${Math.round(total / goodComps.length).toLocaleString()}`;
};

export const computeFAR = (lotSizeString) => {
    const lotSize = parseFloat(lotSizeString);
    if (!lotSize) {
        return 'NA';
    }
    let temp = PropertyInfo.FutureHomeSize / lotSize;
    temp *= 100.0;
    temp = temp.toFixed(1);

    return temp + ' %';
};

export const computeWeightedAvgSalePrice = (comps) => {
    const goodComps = comps.filter((comp) => Number(comp.sale_price) > 0);
    let weightedTotal = 0;
    let totalWeight = 0;
    for (const comp of goodComps) {
        weightedTotal += comp.weight * comp.sale_price;
        totalWeight += comp.weight;
    }
    const weightedAvg = Math.round(weightedTotal / totalWeight);
    return { value: weightedAvg, formatted: `$${weightedAvg.toLocaleString()}` };
};

export const formatStreetAddress = (address) => {
    const commaIndex = address.lastIndexOf(',');
    return commaIndex >= 0
        ? address.slice(0, commaIndex).toLowerCase()
        : address.toLowerCase();
};

export const computeAvgSFPrice = (comps) => {
    const goodComps = comps.filter((comp) => Number(comp.price_sf) > 0);
    const total = goodComps.reduce((acc, comp) => acc + Number(comp.price_sf), 0);
    return `$${Math.round(total / goodComps.length).toLocaleString()}`;
};

export const canDisplayCard = (cardName, userProfile) => {
    switch (cardName) {
    case 'SourceAndStatusCard':
        return userProfile === UserTypes.aro;
    default:
        return true;
    }
};

export const updatePropertyScoutFields = (currentFields, field, value) => {
    let updatedFields = { ...currentFields };
    updatedFields[field] = value;
    return updatedFields;
};

export const getViabilityDocLink = (viabilityKey, property) => {
    let city;
    let county;

    switch (viabilityKey) {
    case ValidationKeys.StructuralConstraints:
    case ValidationKeys.FloodHazard:
    case ValidationKeys.EarthquakeHazard:
    case ValidationKeys.FireHazard:
        return ViabilityLinks[viabilityKey];

    case ValidationKeys.CityHistoricResource:
    case ValidationKeys.ZoningJurisdiction:
        city = property?.City?.name || null;
        return city
            ? ViabilityLinks[viabilityKey][city.toUpperCase()] || null
            : null;
    case ValidationKeys.CityVsCounty:
        county = property?.City?.county || null;
        return county
            ? ViabilityLinks[viabilityKey][county.toUpperCase()] || null
            : null;
    default:
        return null;
    }
};
